import { ReviewCycleStateType } from './ReviewCycle.type';
import { ReviewTemplateVersion, ReviewTemplateTypeType } from './ReviewTemplates.type';

export enum ReviewState {
  PEER_REVIEW = 'peer_review',
  COMPILATION = 'compilation',
  COMPILATION_COMPLETED_BUT_NOT_SHARED = 'compilation_completed_but_not_shared',
  CANCELLED = 'cancelled',
  SHARED = 'shared',
  COMPLETED = 'completed', // Legacy 360 functionality
  CLOSED = 'closed',
}

export enum RecieverShareSetting {
  peer_reviews_not_shared = 'peer_reviews_not_shared',
  anonymized_peer_reviews_shared = 'anonymized_peer_reviews_shared',
}

export type ReviewType = {
  compilerSlug: string;
  // Intent was to sit with your IC and discuss the review, then mark it as completed after that, not used
  completedAt: string;
  creatorSlug: string;
  closedAt: string; // ISO Date
  dueBy: number;
  unlockedAt: number;
  peerReviewsDueBy: number;
  managerPeerReviewDueBy: number;
  receiverViewedAt: number;
  receiverSlug: string;
  slug: string;
  state: ReviewState;
  reviewTemplateVersion: ReviewTemplateVersion;
  reviewTemplateType: ReviewTemplateTypeType;
  peerReviewRecipientSharingSetting: RecieverShareSetting;
  reviewCycleSlug: string;
  reviewCycleName: string;
  reviewCycleState: ReviewCycleStateType;
  self360: boolean;
  cancelledAt: number; // Legacy 360 feature
};
